import { Autocomplete } from '@mui/material'
import { TextField } from '@dhl-ui/components'
import { LabelValue } from '~/common/model'

type Props = {
  value: LabelValue[]
  label: string
  options: LabelValue[]
  onChange: (value: string[]) => void
}

export const MultiTagAutoComplete = ({ value, label, options, onChange }: Props) => {
  const handleChange = (event: any, selectedItems: LabelValue[]) => {
    const value = selectedItems.map((item) => item.value)
    onChange(value)
  }

  return (
    <Autocomplete
      value={value}
      multiple
      disableCloseOnSelect
      options={options}
      autoHighlight
      fullWidth
      onChange={handleChange}
      getOptionLabel={(option: LabelValue) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            input: { ...params.InputProps, sx: { paddingLeft: '12px !important', paddingTop: '8px !important' } },
          }}
        />
      )}
    />
  )
}
